import React from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Alignment from '../buttons/Alignment';
import Delete from '../buttons/Delete';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { getExtensionOptions, shouldBlockMenuBeOpen } from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import Edit from '../buttons/Edit';
import { EXTENSION_TYPE_NAME } from '../../constants';
const MenuButtons = ({ editor, forMobile = false })=>{
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(!forMobile && 'ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, options.canAlign && /*#__PURE__*/ React.createElement(Alignment, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Edit, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Delete, {
        editor: editor
    }));
};
const DaGifBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable) || isTouch()) {
        return null;
    }
    const open = shouldBlockMenuBeOpen(editor, EXTENSION_TYPE_NAME);
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    let buttonCount = 3;
    if (!options.canAlign) {
        buttonCount--;
    }
    return /*#__PURE__*/ React.createElement(BlockBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 38,
        menuWidth: 40 * buttonCount,
        editor: editor,
        open: open,
        childSelector: "video"
    }, /*#__PURE__*/ React.createElement(MenuButtons, {
        editor: editor
    }));
};
DaGifBubbleMenu.displayName = 'DaGifBubbleMenu';
export default DaGifBubbleMenu;
export { MenuButtons };

//# sourceMappingURL=DaGifBubbleMenu.js.map